import React from "react";
import "./aboutView.css";
import Heading from "../Heading";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";

export class About extends React.Component {
  constructor(args) {
    super(args);
    this.state = {};
  }
  render() {
    return (
      <div className="section__content">
        <div className="about__wrapper">
          <div className="about__section">
            <div className="about_content">
              <div className="">
                <Heading title="Overview" />
              </div>
              {/*
								<div className="video_section">
									<div className="video_text">
										<iframe className="resp-iframe" style={{ margin: "0 auto" }} width="100%" src="https://www.youtube.com/embed/q-bE10X9KcA" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
									</div>
								</div>
							*/}
              <div>
                <div className="left_section">
                  <div className="left_content">
                    <div className="left_text">
                      <ScrollAnimation
                        delay={0}
                        duration={2}
                        animateIn="zoomIn"
                        offset={300}
                      >
                        <div className="winpe__quotes">
                          {" "}
                          Private equity and venture capital lag other
                          industries in diversity statistics{" "}
                        </div>
                        <div className="red_border"></div>
                      </ScrollAnimation>
                      <div className="left_video">
                        <div className="left_video_section">
                          <iframe
                            className="resp-iframe"
                            style={{ margin: "0 auto" }}
                            width="100%"
                            src="https://www.youtube.com/embed/iu6jR-ANYls"
                            frameBorder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="right_section">
                  <div className="right_content">
                    <ScrollAnimation
                      delay={0}
                      duration={2}
                      animateIn="slideInRight"
                      offset={600}
                    >
                      <div>
                        <div>
                          {/* <div className="low__heading"></div>
													<div className="">
														<Heading title="Overview" />
													</div>
													*/}
                          <div className="right_text">
                          Winpe is a pioneering, not for profit platform to
                            bring about transformation in the investing world in
                            favour of gender diversity.
                          </div>
                          <div className="right_text">
                          Winpe is the industry forum where stakeholders come
                            together to set the diversity agenda and lead
                            collective action to create gender balance in the
                            investing ecosystem. Winpe is committed to
                            catalysing action in increasing participation of
                            women as investors, capital allocators and as
                            recipients of investment capital, through a
                            well-rounded and holistic approach that engages key
                            stakeholders of the investing industry.
                          </div>
                          <div className="right_text">
                            Although women make up roughly half of the available
                            talent pool, they continue to be significantly
                            underrepresented among the investment
                            decision-makers at private equity and venture
                            capital (PEVC) firms, as well as in the leadership
                            of companies that receive this investment capital.
                            Gender balance in investors is a powerful agent for
                            driving diversity in boardrooms, in the c-suite,
                            within the workplace and within business linkages.
                            Gender and diversity is a top-down agenda and the
                            dialogue has to start at the very top of the capital
                            structure, where corporate ownership resides and
                            where all key decisions originate.
                          </div>
                        </div>
                      </div>
                    </ScrollAnimation>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="section_divider1">
            <img
              src="https://winpeforum.com/assets/elements/Section_divier_gray.png"
              width="100%"
              alt="Section_divier_gray"
              className="img-responsive"
            />
          </div>
          <div className="section_divider">
            <img
              src="https://winpeforum.com/assets/elements/phone_section_divider.png"
              width="100%"
              alt="Section_divier_gray"
              className="img-responsive"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/about/index.js